import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './plugins/i18n'

createApp(App).use(i18n).use(store).mount('#tx-testimonials-testimonial-list')
